export const PARTNER_EXPERIENCES_TABLET_VISIBLE_COUNT = 3
export const PARTNER_EXPERIENCES_DESKTOP_VISIBLE_COUNT = 6

export type PartnerExperiencesBreakpoint = 'mobile' | 'tablet' | 'desktop'

export function getPartnerExperiencesBreakpoint(
  isSm: boolean | undefined,
  isMd: boolean | undefined
): PartnerExperiencesBreakpoint {
  // Media state is unavailable during SSR. Use the bounded desktop shape so
  // the server never renders the full list before hydration.
  if (isSm === undefined || isMd === undefined) return 'desktop'

  if (!isSm) return 'mobile'
  return isMd ? 'desktop' : 'tablet'
}

// Slicing is client-side because the full list is already loaded for the map.
export function getVisiblePartnerExperiencesCount(
  totalCount: number,
  breakpoint: PartnerExperiencesBreakpoint,
  showAll: boolean
): number {
  if (breakpoint === 'mobile' || showAll) return totalCount

  const visibleCount =
    breakpoint === 'desktop'
      ? PARTNER_EXPERIENCES_DESKTOP_VISIBLE_COUNT
      : PARTNER_EXPERIENCES_TABLET_VISIBLE_COUNT

  return Math.min(totalCount, visibleCount)
}
